import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgFrenchFlagRounded = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.992.682v22.55a11.902 11.902 0 0 0 4.506-2.857c4.649-4.691 4.615-12.263-.077-16.912a11.91 11.91 0 0 0-4.429-2.78Z",
    fill: "#E60012"
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97.698v22.516c2.589.927 5.432.932 8.022.018V.682A12.004 12.004 0 0 0 7.97.698Z",
    fill: "#fff"
  }), _jsx("mask", {
    id: "french-flag-rounded_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 24,
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 .682h7.97v22.55H0V.682Z",
      fill: "#fff"
    })
  }), _jsx("g", {
    mask: "url(#french-flag-rounded_svg__a)",
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.97.682v22.55a11.898 11.898 0 0 1-4.505-2.857c-4.65-4.692-4.615-12.263.076-16.912A11.908 11.908 0 0 1 7.97.682Z",
      fill: "#0B318F"
    })
  })]
}));
export default SvgFrenchFlagRounded;